import type { SupabaseClient } from '@supabase/supabase-js';

export type NoteTarget = { type: 'session' } | { type: 'exercise'; exerciseKey: string } | { type: 'set'; exerciseKey: string; setId: string };
export type NoteRow = { id: string; target_type: NoteTarget['type']; exercise_key: string | null; set_id: string | null; body: string };

export function noteKey(t: NoteTarget): string {
  return t.type === 'session' ? 'session' : t.type === 'exercise' ? `exercise:${t.exerciseKey}` : `set:${t.setId}`;
}
export function rowKey(n: NoteRow): string {
  return n.target_type === 'session' ? 'session' : n.target_type === 'exercise' ? `exercise:${n.exercise_key}` : `set:${n.set_id}`;
}

export async function listNotes(client: SupabaseClient, sessionId: string): Promise<Record<string, string>> {
  const { data, error } = await client.from('notes').select('id,target_type,exercise_key,set_id,body').eq('session_id', sessionId);
  if (error) throw error;
  const out: Record<string, string> = {};
  for (const n of data as NoteRow[]) out[rowKey(n)] = n.body;
  return out;
}

/** Empty body deletes the note. */
export async function saveNote(client: SupabaseClient, sessionId: string, target: NoteTarget, body: string) {
  const { error } = await client.rpc('save_note', {
    p_session_id: sessionId,
    p_target_type: target.type,
    p_exercise_key: target.type === 'session' ? null : target.exerciseKey,
    p_set_id: target.type === 'set' ? target.setId : null,
    p_body: body,
  });
  if (error) throw error;
}
